<template>
  <el-container class="clues_manage" >
    
    <el-header class="header-style">
    <el-divider content-position="left">业绩排名</el-divider>
    <div class="changeHeight m-tabs-content" style="overflow-y: visible">
      <el-row type="flex" >
        <el-tooltip effect="dark" content="起始时间" placement="top">
          <el-col :span="4">
            <div>
              <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="至"
                size="mini"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                @change="pickerDataChange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="ysyTypeInPickerOptions">
              </el-date-picker>
            </div>
          </el-col>
        </el-tooltip>
        <el-col :span="4" :offset="1">
          <el-select
            :filterable="true"
            multiple
            collapse-tags
            v-model="highSearch.combo"
            placeholder="请选择套餐名称"
            size="mini"  clearable>
            <el-option
              v-for="(item, index) in combo"
              :key="index"
              :label="item.combo_name"
              :value="item.combo_id" >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-select
            :filterable="true"
            multiple
            collapse-tags
            v-model="highSearch.items"
            placeholder="请选择单品类型"
            size="mini"  clearable>
            <el-option
              v-for="(item, index) in items"
              :key="index"
              :label="item.item_name"
              :value="item.item_id" >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-select
            v-model="valueChange"
            multiple
            filterable
            collapse-tags
            size="mini"
            placeholder="请选择角色"
            :popper-append-to-body="false"
            @change="handelColCange">
            <el-option v-for="(item, index) in roles" :label="item.role_name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5" class="tr">
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
          <el-button type="danger" size="mini" @click="handleCloseSearch">清除</el-button>
        </el-col>
      </el-row>
    </div>
    <el-row class="mb-10" style="margin-top: 0">
      <el-col :span="3" style="display: flex" v-if="false">
        <div class="level count_style">
          <span class="count" style="color: #5787FF">客户意向：</span>
          <i class="el-icon-question" @click="dialogVisible3 = true"></i>
        </div>
      </el-col>
      <el-col :span="16" style="display: flex">
        <div class="level_num count_style" >
          <span class="count"  style="display: inline-block; width: 1rem;">云上：{{couldMealItem.total_could }}</span>
          <span class="count"  style="display: inline-block; width: 1rem; margin-left: .4rem">套餐：{{couldMealItem.total_meal  }}</span>
          <span class="count"  style="display: inline-block; width: 1rem; margin-left: .4rem">单品：{{couldMealItem.total_item }}</span>
        </div>
      </el-col>
    </el-row>
  </el-header>

<el-main class="main-style">
    <el-table
    height="calc(100vh - 306px)"
    :data="pageData"
    v-if="!loadingStatus"
    @sort-change="sortChange"
    :header-cell-style="getRowClass"
    size="medium"
    border
    style="width: 100%;">
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :fixed="index < 4"
        sortable="custom"
        :width="tableColumn(item.prop, item.label)">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="60" v-if="false">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" content="沟通记录/线索历史" placement="top">
            <el-button type="success" size="mini" icon="el-icon-time" @click="handleContactOpen(scope.$index, scope.row)" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div v-else class="loading-placeholder">加载中，请稍后...</div>
  </el-main>

  </el-container>
</template>

<script>
import {fscDate} from '../../../static/mixins/fastChooseDate'
export default {
  name: 'pfm_ranking',
  mixins: [fscDate],
  data () {
    return {
      loadingStatus: true,
      percentNum: '',
      count: '',
      cluesNum: '',
      cluesIndex: 0,
      CluesManage: [],
      OperationRecord: [],
      ContactDrawer: false,
      search: '',
      value1: [],
      valueChange: [],
      roles: [],
      value3: [],
      value5: false,
      options: [],
      ConversionPeople: [],
      activities: [],
      intentionData: {},
      highSearch: {
        start_time: '',
        end_time: '',
        combo: '',
        items: '',
        sort_field: '',
        sort_by: 0,
        role_ids: []
      },
      optionProps: {
        value: 'id',
        label: 'Provincial',
        children: 'son'
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      col: [],
      activeName: 'first',
      combo: [],
      items: [],
      tabData: [],
      couldMealItem: {}
    }
  },
  computed: {
    pageData: function () {
      return this.tabData
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.tabData.length
      this.pageOption.currentPage2 = 1
    }
  },
  methods: {
    handelColCange (val) {
      this.highSearch.role_ids = val
    },
    // 给表单的表头添加背景颜色
    getRowClass ({row, column, rowIndex, columnIndex}) {
      var title = []
      for (var a = 4; a < row.length; a++) {
        title.push(row[a].property)
      }
      if (title.indexOf(column.property) !== -1) {
        return 'overflow: hidden;text-overflow: ellipsis;white-space: nowrap'
      }
    },
    sortChange (column) {
      if (column.order === 'descending') {
        this.handelGetOrders(
          this.highSearch.start_time,
          this.highSearch.end_time,
          this.highSearch.combo,
          this.highSearch.items,
          column.prop,
          0,
          this.highSearch.role_ids
        )
      } else if (column.order === 'ascending') {
        this.handelGetOrders(
          this.highSearch.start_time,
          this.highSearch.end_time,
          this.highSearch.combo,
          this.highSearch.items,
          column.prop,
          1,
          this.highSearch.role_ids
        )
      } else {
        this.handelGetOrders(
          this.highSearch.start_time,
          this.highSearch.end_time,
          this.highSearch.combo,
          this.highSearch.items,
          '',
          '',
          this.highSearch.role_ids
        )
      }
    },
    tableColumn (prop, label) {
      let lengths = label.replace(/[^\u4e00-\u9fa5]/gi, '').length
      if (prop === 'username') {
        return 100
      }
      if (lengths <= 6) {
        return lengths * 30
      } else if (lengths === 8) {
        return lengths * 28
      } else {
        return lengths * 23
      }
    },
    provinceCityData () {
      this.$axios.get('/api/thread/cities')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            for (var a = 0; a < data.data.length; a++) {
              this.options.push(data.data[a])
            }
          }
        })
    },
    getFeedBack (key) {
      let vipData = [' ', '电话联系', '手机短信', '发送快递', '微信交流', '见面拜谈', '公司洽谈', '优开平台']
      return vipData[key]
    },
    handleAddDrawerBeforeClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearAddData()
          done()
        })
        .catch(_ => {})
    },
    clearAddData () {
      this.activities = []
      this.OperationRecord = []
    },
    handelGetSerach () {
      this.$axios.get('/api/threadstat/combo_items', {})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.combo = data.data.combo
            this.items = data.data.items
          }
        })
    },
    handelGetOrders (startTime, endTime, Combo, items, sortField, sortBy, roleIds) {
      this.$axios.post('/api/threadstat/pfm_stat', {
        start_time: startTime,
        end_time: endTime,
        combo_ids: Combo,
        item_ids: items,
        sort_field: sortField,
        sort_by: sortBy,
        role_ids: roleIds
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.couldMealItem = data.data.total_count
            this.col = data.data.header
            this.tabData = data.data.data
            this.roles = data.data.roles
            this.pageOption.total = this.tabData.length
          }
        }).finally(() => {
          this.loadingStatus = false;
        })
        .catch((err) => {
          this.loadingStatus = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
    },
    searchTotal () {
      return this.tabData.filter(data => !this.search || (data.custom_name && data.custom_name.toLowerCase().includes(this.search.toLowerCase())) || (data.custom_phone && data.custom_phone.toLowerCase().includes(this.search.toLowerCase()))).length
    },
    groupInput (val) {
      this.highSearch.group_chat_id = val
    },
    pickerDataChange (val) {
      if (!val) {
        this.highSearch.start_time = []
        this.highSearch.end_time = []
      } else {
        this.highSearch.start_time = val[0]
        this.highSearch.end_time = val[1]
      }
    },
    handleChangeSearch (value) {
      this.highSearch.custom_city_name[0] = value[0]
      this.highSearch.custom_city_name[1] = value[1]
    },
    handleSearch () {
      this.handelGetOrders(
        this.highSearch.start_time,
        this.highSearch.end_time,
        this.highSearch.combo,
        this.highSearch.items,
        this.highSearch.sort_field,
        this.highSearch.sort_by,
        this.highSearch.role_ids
      )
    },
    handleCloseSearch () {
      this.value1 = []
      this.valueChange = []
      this.highSearch.combo = ''
      this.highSearch.start_time = ''
      this.highSearch.end_time = ''
      this.highSearch.items = ''
      this.highSearch.sort_field = ''
      this.highSearch.sort_by = ''
      this.highSearch.role_ids = ''
      this.handelGetOrders(
        this.value1,
        this.value1,
        this.highSearch.combo,
        this.highSearch.items,
        this.highSearch.sort_field,
        this.highSearch.sort_by,
        this.highSearch.role_ids
      )
    }
  },
  mounted () {
    this.handelGetOrders()
    this.handelGetSerach()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .clues_manage
    marginLeft()
    max-height: 100vh
    .header-style
      z-index: 2
      height: 154px !important
      padding: 0px !important
    .main-style
      z-index: 1
      padding: 0px !important
      // overflow-y: auto
    .count_style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .tr
    text-align: right
  .m-tabs-content
    overflow-y auto
    .m-label
      line-height: .64rem
    .text_right
      text-align left
    .el-row
      margin-bottom: .4rem
  .clues_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  /*.clues_manage >>> .el-table__header thead .is-hidden*/
  /*  color: red*/
  /*  background-color: #ECF4FF*/
  /*  font-size 16px*/
  .mb-10
    margin-bottom: .2rem
    margin-top: 0.4rem;
  .mt-10
    margin-top: .2rem
  .level
    display flex
    align-items center
    position relative
    padding-right .32rem
    img
      width .32rem
      height .30rem
    .el-icon-question
      margin-left: .1rem
      color: #409EFF
      position absolute
      top 0
      right 0
      cursor pointer
  .el-select, .el-cascader
    width: 100%
  .count
    padding-left: .2rem
    line-height: .56rem
  .el-position
    position relative
    .dot
      display inline-block
      width 0.1rem
      height 0.1rem
      border-radius 50%
      margin-right 0.1rem
      position absolute
      top 0
      left -.2rem
      bottom 0
      margin auto
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .changeHeight
    padding .2rem
    margin-top .4rem
  .el-collapse
    border-bottom 0
    border-top 0
  .el-collapse >>> .el-collapse-item__header
    color: #4C87FC
    font-weight bold
  .el-collapse >>> .el-collapse-item__arrow
    color: #4C87FC
  .el-collapse >>> .el-collapse-item__content
    padding-bottom 0
  .el_dialogs >>> .el-dialog__body
    padding-left 0
    padding-right 0
  .el_dialogs >>> .el-dialog__header
    padding 0

  .block
    height 6rem
    overflow-y auto
    padding-top .2rem
    padding-left .2rem
    box-sizing border-box

    .time_right
      width 100%
      margin-top .4rem
      overflow hidden
      word-break break-all
      white-space normal
  .el-timeline-item__node--large
    width .4rem
    height .4rem
  /*滚动条整体样式*/
  ::-webkit-scrollbar{
    width: .1rem;/*竖向滚动条的宽度*/
    height: 10px;/*横向滚动条的高度*/
  }
  ::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
    background: #cdcdcd;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-track{/*滚动条轨道的样式*/
    background: #f8f8f8;
    border-radius: 5px;
  }
  .el-date-editor
    width: 100% !important
  .loading-placeholder
    text-align: center;
    padding: 20px;

</style>



// WEBPACK FOOTER //
// src/pages/pfm_ranking/pfm_ranking.vue